import { PageShell, PageTitle } from '@components'
import cn from '@integrations/classnames'
import { useState } from '@integrations/react'
import { LimitsTable, RequestsTable } from '@requests'
import { CustomerRoles, selectCurrentUserRole, useAppSelector } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import styles from './RequestsView.module.scss'

const REQUESTS_TABS = Object.freeze({
  REQUESTS: 'requests',
  LIMITS: 'limits'
} as const)

type Tabs = (typeof REQUESTS_TABS)[keyof typeof REQUESTS_TABS]

function RequestsView() {
  const customerRole = useAppSelector(selectCurrentUserRole)

  const [activeTab, setActiveTab] = useState<Tabs>(REQUESTS_TABS.REQUESTS)

  function handleTabClick(tab: Tabs): void {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <PageShell className={cn('requests-wrapper')}>
      {customerRole === CustomerRoles.STAFF ? (
        <PageTitle variant='responsive' className={cn('requests-title')}>
          {tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_REQUESTS', 'Expense requests')}
        </PageTitle>
      ) : (
        <div className={cn('expenses-header')}>
          <PageTitle variant='responsive' className={cn('requests-title')}>
            {tr('FRONTEND.EXPENSE_MANAGEMENT.REQUESTS_TITLE', 'Requests')}
          </PageTitle>

          <div className={cn(styles['requests-tabs-wrapper'], 'requests-tabs-wrapper')}>
            <div
              className={cn(styles['requests-tab'], 'requests-tab', {
                [styles['is-active']]: activeTab === REQUESTS_TABS.REQUESTS,
                'is-active': activeTab === REQUESTS_TABS.REQUESTS
              })}
              onClick={() => handleTabClick(REQUESTS_TABS.REQUESTS)}
              data-test='requests-tab'
            >
              {tr('FRONTEND.EXPENSE_MANAGEMENT.TAB_EXPENSE_REQUESTS', 'Expense requests')}
            </div>
            <div
              className={cn(styles['requests-tab'], 'requests-tab', {
                [styles['is-active']]: activeTab === REQUESTS_TABS.LIMITS,
                'is-active': activeTab === REQUESTS_TABS.LIMITS
              })}
              onClick={() => handleTabClick(REQUESTS_TABS.LIMITS)}
              data-test='limits-tab'
            >
              {tr('FRONTEND.EXPENSE_MANAGEMENT.TAB_LIMITS', 'Limits')}
            </div>
          </div>
        </div>
      )}
      <div>
        {activeTab === REQUESTS_TABS.REQUESTS || customerRole === CustomerRoles.STAFF ? <RequestsTable /> : null}
        {activeTab === REQUESTS_TABS.LIMITS ? <LimitsTable /> : null}
      </div>
    </PageShell>
  )
}

export default RequestsView
